import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Store } from '@ngrx/store';
import { TranslateService } from '@ngx-translate/core';
import { firstValueFrom } from 'rxjs';
import { TagsApiService } from 'src/app/apis/tags-api.service';
import { Common } from 'src/app/lib/common-methods';
import { LocalStorageService } from 'src/app/lib/local-storage.service';
import { Reservation } from 'src/app/model/reservation';
import { ReservationTag, ReservationTagCategory } from 'src/app/model/reservation-tag';
import { TagType } from 'src/app/model/tag-type';
import { createTagUpdateDTO } from 'src/app/model/tags.dto';
import * as AppActions from '../../store/actions/app.actions';
import { NgxSpinnerService } from 'ngx-spinner';
import { environment } from 'src/environments/environment';
declare let $: any;

@Component({
  selector: 'app-tags-modal',
  templateUrl: './tags-modal.component.html',
  styleUrls: ['./tags-modal.component.scss']
})
export class TagsModalComponent implements OnInit {

  constructor(private translate: TranslateService,
    private tagsApi: TagsApiService,
    private localStorageService: LocalStorageService,
    private spinner: NgxSpinnerService,
    private store: Store<{ reservations: Reservation[] }>,
  ) { }

  activeTab: number = 0;

  @Input() modalId: string = "tags-modal";
  @Input() tagCategories: ReservationTagCategory[] = [];
  @Input() selectedTags: ReservationTag[] = [];
  @Input() tagType: TagType = "RESERVATION";
  @Input() displayCategoryLabel: boolean = true;
  @Input() displayAdditionalTextInput: boolean = false;
  @Input() additionalTextInput: string | undefined = '';

  @Output() setTags = new EventEmitter<ReservationTag[]>();
  @Output() setAdditionalTextInput = new EventEmitter<string>();

  selectedTag: ReservationTag = new ReservationTag();

  isTagValid: boolean = false;
  tagErrorMessage: string = "";
  tagsSelection: ReservationTag[] = [];
  _additionalTextInput: string | undefined = '';

  private tagStartOrder: number = 0;
  private tagStartName: string = "";

  ngOnInit(): void {
    this.selectedTag.tagOrder = undefined;
  }

  show() {
    this.activeTab = 0;

    this.tagsSelection = this.selectedTags;
    this._additionalTextInput = this.additionalTextInput;

    $('#' + this.modalId).modal("show");
  }

  closeModal(result: boolean) {
    
    if (result === true) {
      this.setTags.emit(this.tagsSelection);
      this.setAdditionalTextInput.emit(this._additionalTextInput);
    }

    $('#' + this.modalId).modal("hide");
  }

  updateValidity() {
    const cat = this.tagCategories.find(c => c.id == this.selectedTag?.categoryId);
    this.selectedTag.title = this.selectedTag?.title?.trim();

    this.tagErrorMessage = "";
    if (Common.isNullOrEmpty(this.selectedTag?.title) || cat == null) {
      this.tagErrorMessage = this.translate.instant('common.requiredFields');
    } else if (cat.tags.find(c => c.id != this.selectedTag.id && c.title == this.selectedTag.title) != null) {
      this.tagErrorMessage = this.translate.instant('common.nameIsUsed');
    }

    this.isTagValid = Common.isNullOrEmpty(this.tagErrorMessage);
  }

  async saveTag(tag: ReservationTag) {
    this.updateValidity();

    if (!this.isTagValid) {
      return;
    }

    const cat = this.tagCategories.find(c => c.id == tag.categoryId)!;
    const updateDto = createTagUpdateDTO(
      this.localStorageService.getRestaurantId() + "", cat, this.tagType, tag, this.tagStartOrder, this.tagStartName
    );
    if (updateDto == null) {
      return;
    }

    try {
      this.spinner.show();
      await firstValueFrom(this.tagsApi.saveTags(updateDto));
      this.spinner.hide();
    } catch (ex) {
      this.spinner.hide();
    }

    this.store.dispatch({ type: AppActions.loadTags.type });
    // this.onClose.emit(this.selectedTag);

    this.cancelAddTag();
  }

  cancelAddTag() {
    // clear fields
    this.selectedTag = new ReservationTag();
    this.selectedTag.tagOrder = undefined;
    // switch to the 'Select' tab
    this.activeTab = 0;
  }

  setReservationTags(tags: ReservationTag[]) {
    this.tagsSelection = tags;
  }

  onSetAdditionalTextInput(text: string) {
    this._additionalTextInput = text;
  }

}
